const APP_ORIGIN = "https://app.sentinelzone.com";

export function buildAppLoginUrl(lang = "es") {
  const params = new URLSearchParams({
    utm_source: "sentinelzone-product-landing",
    utm_medium: "header",
    utm_campaign: "login",
    utm_language: lang,
  });
  return `${APP_ORIGIN}/signin?${params.toString()}`;
}
